module.exports = __webpack_public_path__ + "static/img/what-get-img-2.bae123e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/what-get-img-2.png
// module id = PjIM
// module chunks = 0